import { Suspense, lazy, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import PhoneFallback from './PhoneFallback';
import { prefersReducedMotion } from '../../hooks/useScrollReveal';

const Hero3D = lazy(() => import('./Hero3D'));

function isWebGLAvailable() {
  try {
    const canvas = document.createElement('canvas');
    return Boolean(
      window.WebGLRenderingContext &&
        (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')),
    );
  } catch {
    return false;
  }
}

// Decides between the live 3D scene and the static fallback, and only loads the
// heavy Three.js bundle on the client when it can actually render.
export default function Hero3DMount() {
  const [canRender3D, setCanRender3D] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(window.innerWidth < 900);
    if (!prefersReducedMotion() && isWebGLAvailable()) {
      setCanRender3D(true);
    }
  }, []);

  if (!canRender3D) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
        <PhoneFallback />
      </Box>
    );
  }

  return (
    <Suspense fallback={<Box sx={{ height: '100%' }} />}>
      <Hero3D isMobile={isMobile} />
    </Suspense>
  );
}
